var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaseNews = function SvgCaseNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 76,
    fill: "none",
    viewBox: "0 0 121 76"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2229_8274",
    width: 121,
    height: 76,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    x: 0.5,
    fill: "#D9D9D9",
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2229_8274)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2229_8274)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BC1BC6",
    d: "M120.5 0H0.5V76H120.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M24 60.9C22.4 60.9 21 59.6 21 57.9V24.5C21 22.8 22.3 21.5 24 21.5H69.8C71.4 21.5 72.8 22.8 72.8 24.5V57.8C72.8 59.4 71.5 60.8 69.8 60.8H24V60.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M54.1 11.1992H41.8C39.6 11.1992 37.8 12.9992 37.8 15.1992V19.9992H25C22.8 19.9992 21 21.7992 21 23.9992V57.2992C21 59.4992 22.8 61.2992 25 61.2992H70.8C73 61.2992 74.8 59.4992 74.8 57.2992V23.9992C74.8 21.7992 73 19.9992 70.8 19.9992H58.1V15.0992C58.1 12.9992 56.3 11.1992 54.1 11.1992ZM39.8 15.1992C39.8 14.0992 40.7 13.1992 41.8 13.1992H54.1C55.2 13.1992 56.1 14.0992 56.1 15.1992V19.9992H39.8V15.1992ZM72.8 57.3992C72.8 58.4992 71.9 59.3992 70.8 59.3992H25C23.9 59.3992 23 58.4992 23 57.3992V36.0992L42.5 42.3992V44.9992C42.5 45.9992 43.3 46.7992 44.3 46.7992H51.6C52.6 46.7992 53.4 45.9992 53.4 44.9992V42.3992L72.9 36.1992V57.3992H72.8ZM44.5 44.7992V37.9992H51.3V44.7992H44.5ZM70.8 21.9992C71.9 21.9992 72.8 22.8992 72.8 23.9992V34.0992L53.3 40.2992V37.5992C53.3 36.5992 52.5 35.7992 51.5 35.7992H44.2C43.2 35.7992 42.4 36.5992 42.4 37.5992V40.1992L23.1 33.9992V23.9992C23.1 22.8992 24 21.9992 25.1 21.9992H70.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M60.7 64.6C59.4 64.6 58.3 63.5 58.3 62.2V35.9C58.3 34.6 59.4 33.5 60.7 33.5H96.9C98.2 33.5 99.3 34.6 99.3 35.9V62.2C99.3 63.5 98.2 64.6 96.9 64.6H60.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M96.6 32.6008H88.7H88.2V32.1008V28.9008C88.2 26.4008 86.1 24.3008 83.6 24.3008H73.7C71.2 24.3008 69.1 26.4008 69.1 28.9008V32.1008V32.6008H68.5H60.5C58.6 32.6008 57.1 34.1008 57.1 36.0008V41.7008V43.8008V61.5008C57.1 63.4008 58.6 64.9008 60.5 64.9008H96.5C98.4 64.9008 99.9 63.4008 99.9 61.5008V44.0008V41.9008V35.9008C99.9 34.1008 98.4 32.6008 96.6 32.6008ZM71 32.1008V29.7008V28.7008C71 27.5008 72.3 26.2008 73.5 26.2008H83.5C84.7 26.2008 86 27.6008 86 28.8008V29.7008V32.1008V32.5008H71V32.1008ZM97.9 44.9008V57.1008V61.5008C97.9 62.3008 97.3 62.9008 96.5 62.9008H60.5C59.7 62.9008 59.1 62.3008 59.1 61.5008V57.1008V44.6008V44.4008L73.4 49.0008V51.6008C73.4 52.6008 74.2 53.4008 75.2 53.4008H82.5C83.5 53.4008 84.3 52.6008 84.3 51.6008V49.0008L98 44.6008V44.9008H97.9ZM75.4 51.3008V44.5008H82.2V51.3008H75.4ZM84.2 46.9008V44.2008C84.2 43.2008 83.4 42.4008 82.4 42.4008H75.1C74.1 42.4008 73.3 43.2008 73.3 44.2008V46.8008L59.1 42.2008V41.8008V38.0008V35.9008C59.1 35.1008 59.7 34.5008 60.5 34.5008H96.5C97.3 34.5008 97.9 35.1008 97.9 35.9008V38.0008V42.2008V42.6008L84.2 46.9008Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2229_8274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    x: 0.5,
    fill: "white",
    rx: 8
  })))));
};
export default SvgCaseNews;